<script>
import Layout from "../../layouts/auth";
import appConfig from "@/app.config";
import { required, email } from "vuelidate/lib/validators";
import { sendForgotPasswordEmail } from "../../../api/services/resetTicket.service";

/**
 * Forgot Password component
 */
export default {
  page: {
    title: "Forgot Password",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
  },
  data() {
    return {
      email: "",
      submitted: false,
      errorMsg: null,
      tryingToReset: false,
      isResetError: false,
      successMsg: null,
      isResetSuccess: false,
    };
  },
  validations: {
    email: {
      required,
      email,
    },
  },
  methods: {
    async tryToReset() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        const res = await sendForgotPasswordEmail(this.email);
        if (res) {
          this.errorMsg = this.$i18n.t("auth.forgetPassword.errorMsg");
          this.isResetError = true;
        } else {
          this.successMsg = this.$i18n.t("auth.forgetPassword.successMsg");
          this.isResetSuccess = true;
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-light">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">
                    {{ $t("auth.forgetPassword.title") }}
                  </h5>
                  <p>{{ $t("auth.forgetPassword.subTitle") }}</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/auth-forget-background.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img
                      src="@/assets/images/ms-sissi-logo.png"
                      alt
                      height="75"
                    />
                  </span>
                </div>
              </router-link>
            </div>

            <div class="p-2">
              <b-alert
                v-model="isResetError"
                class="mb-4"
                variant="danger"
                dismissible
                >{{ errorMsg }}</b-alert
              >
              <b-alert
                v-model="isResetSuccess"
                class="mb-4"
                variant="success"
                dismissible
                >{{ successMsg }}</b-alert
              >
              <form @submit.prevent="tryToReset">
                <div class="form-group">
                  <label for="useremail">{{
                    $t("auth.login.emailLabel")
                  }}</label>
                  <input
                    type="text"
                    v-model="email"
                    class="form-control"
                    id="useremail"
                    :placeholder="this.$i18n.t('auth.login.emailPlaceholder')"
                    :class="{ 'is-invalid': submitted && $v.email.$error }"
                  />
                  <div
                    v-if="submitted && $v.email.$error"
                    class="invalid-feedback"
                  >
                    <span v-if="!$v.email.required">{{
                      $t("auth.login.emailRequired")
                    }}</span>
                    <span v-if="!$v.email.email">{{
                      $t("auth.login.emailNotValid")
                    }}</span>
                  </div>
                </div>
                <div class="form-group row mb-0">
                  <div class="col-12 text-right">
                    <button class="btn btn-success w-md" type="submit">
                      {{ $t("auth.forgetPassword.resetButton") }}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <p>
            {{ $t("auth.forgetPassword.remeberText") }}
            <router-link
              tag="a"
              to="/login"
              class="font-weight-medium text-primary"
              >{{ $t("auth.forgetPassword.loginText") }}</router-link
            >
          </p>
          <p>
            © {{ new Date().getFullYear() }} Ms-Sissi. Made with
            <i class="mdi mdi-heart text-danger"></i> by AusriLabs
          </p>
        </div>
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>
